// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"42f33b35","788":"92dd4fdc","938":"ab778489"}[chunkId] + ".chunk.css";
};